
import notifications from '~/components/notifications/notifications'
export default
  components: {notifications}
  middleware: ['tokenContext']
  head:
   bodyAttrs:
     style: 'background:#EDEDED;'
